import { useSelector } from 'react-redux'
import { myFilledOrdersSelector } from '../store/selectors'
import sort from '../assets/sort.svg'
import Banner from './Banner'

const MyFilledOrders = () => {
  const symbols = useSelector(state => state.tokens.symbols)
  const myFilledOrders = useSelector(myFilledOrdersSelector)

  return (
    <div className="component exchange__transactions">
      <div className='component__header flex-between'>
        <h2>My Transactions</h2>
      </div>

      {!myFilledOrders || myFilledOrders.length === 0 ? (
        <Banner text='No Transactions' />
      ) : (
        <table>
          <thead>
            <tr>
              <th>Time<img src={sort} alt="Sort" /></th>
              <th>{symbols && symbols[0]}<img src={sort} alt="Sort" /></th>
              <th>{symbols && symbols[0]}/{symbols && symbols[1]}<img src={sort} alt="Sort" /></th>
            </tr>
          </thead>
          <tbody>
            {myFilledOrders.map((order, index) => (
              <tr key={index}>
                <td>{order.formattedTimestamp}</td>
                <td style={{ color: `${order.orderClass}` }}>{order.orderSign}{order.token0Amount}</td>
                <td>{order.tokenPrice}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}

export default MyFilledOrders
